import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';

// Components
import Triangle from '../shared/designElements/Triangle';
import Expand from '../shared/icons/List';
import Cross from '../shared/icons/CloseCross';
import Alert from '../shared/icons/Alert';
import Caret from '../shared/icons/Caret';
import ButtonCaret from '../shared/buttons/ButtonCaret';

// Styles
import { fromBreakpoint, breakpointSizes } from '../../styles/breakpoints';
import { colorPalette, colorPaletteRGB, textStyles } from '../../styles/styleGuide';
import { darken } from '../../styles/utils';
var OptionNotifications = /*#__PURE__*/function (_PureComponent) {
  function OptionNotifications() {
    var _this;
    _classCallCheck(this, OptionNotifications);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OptionNotifications, [].concat(args));
    _defineProperty(_this, "state", {
      expanded: true,
      flippedButton: false,
      showAll: true
    });
    _defineProperty(_this, "notificationButton", null);
    _defineProperty(_this, "MAX_VISIBLE_NOTIFICIATIONS", 8);
    _defineProperty(_this, "scrollToOption", function (optionId) {
      if (document) {
        var optionEl = document.querySelector(".option-".concat(optionId));
        optionEl && optionEl.scrollIntoView({
          behavior: 'smooth',
          // $FlowFixMe
          block: 'center'
        });
      }
    });
    _defineProperty(_this, "toggleExpansion", function () {
      var expanded = _this.state.expanded;
      _this.setState({
        expanded: !expanded
      });
    });
    _defineProperty(_this, "toggleShowAll", function () {
      var showAll = _this.state.showAll;
      _this.setState({
        showAll: !showAll
      });
    });
    _defineProperty(_this, "onResize", function () {
      var flippedButton = _this.state.flippedButton;
      var viewWidth = window.innerWidth;
      if (viewWidth <= breakpointSizes.md && !flippedButton) {
        _this.setState({
          flippedButton: true
        });
      }
      if (viewWidth > breakpointSizes.md && flippedButton) {
        _this.setState({
          flippedButton: false
        });
      }
    });
    _defineProperty(_this, "getAmount", function (notifications) {
      return notifications.newOpts.length + notifications.ordersToConfirm.length;
    });
    return _this;
  }
  _inherits(OptionNotifications, _PureComponent);
  return _createClass(OptionNotifications, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var notifications = this.props.notifications;
      var amount = this.getAmount(notifications);
      if (amount > this.MAX_VISIBLE_NOTIFICIATIONS) {
        this.setState({
          showAll: false
        });
      }
      this.onResize();
      window.addEventListener('resize', this.onResize, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var notifications = this.props.notifications;
      var _this$state = this.state,
        expanded = _this$state.expanded,
        flippedButton = _this$state.flippedButton,
        showAll = _this$state.showAll;
      var notificationAmount = this.getAmount(notifications);
      var itemCounter = 0;
      return __jsx(Container, {
        "data-id": "homestudio_OptionNotifications_Container"
      }, __jsx(Triangle, {
        color: colorPalette.orange,
        direction: flippedButton ? 'bottomright' : 'bottomleft',
        width: 30,
        height: 30,
        "data-id": "homestudio_OptionNotifications_Triangle"
      }), __jsx(NotificationContainer, {
        "data-id": "homestudio_OptionNotifications_NotificationContainer"
      }, __jsx(NotificationText, {
        show: expanded,
        color: colorPaletteRGB.loadingOrange,
        "data-id": "homestudio_OptionNotifications_NotificationText"
      }, __jsx(NotificationTitle, {
        expanded: expanded,
        "data-id": "homestudio_OptionNotifications_NotificationTitle"
      }, __jsx(Alert, {
        color: colorPalette.orange,
        "data-id": "homestudio_OptionNotifications_Alert"
      }), __jsx("span", {
        "data-id": "homestudio_OptionNotifications_span"
      }, "Het woonontwerp bevat ", notificationAmount, " nieuwe aandachtspunten")), __jsx(NotificationLists, {
        show: expanded,
        "data-id": "homestudio_OptionNotifications_NotificationLists"
      }, notifications.newOpts.length > 0 && __jsx(Fragment, null, __jsx(NotificationCategory, {
        "data-id": "homestudio_OptionNotifications_NotificationCategory"
      }, "Nieuw (", notifications.newOpts.length, ")"), __jsx(NotificationList, {
        "data-id": "homestudio_OptionNotifications_NotificationList"
      }, notifications.newOpts.map(function (item, i) {
        var handleOptionClick = function handleOptionClick() {
          return _this2.scrollToOption(item.id);
        };
        itemCounter++;
        return __jsx(NotificationListItem, {
          visible: itemCounter <= _this2.MAX_VISIBLE_NOTIFICIATIONS || showAll,
          key: "notification-newOpts-".concat(i),
          "data-id": "homestudio_OptionNotifications_NotificationListItem"
        }, __jsx(ButtonCaret, {
          clickHandler: handleOptionClick,
          color: colorPalette.blue,
          label: item.title,
          "data-id": "homestudio_OptionNotifications_ButtonCaret"
        }));
      }))), notifications.ordersToConfirm.length > 0 && __jsx(Fragment, null, __jsx(NotificationCategory, {
        "data-id": "homestudio_OptionNotifications_NotificationCategory"
      }, "In afwachting van bevestiging (", notifications.ordersToConfirm.length, ")"), __jsx(NotificationList, {
        "data-id": "homestudio_OptionNotifications_NotificationList"
      }, notifications.ordersToConfirm.map(function (item, i) {
        var handleOptionClick = function handleOptionClick() {
          return _this2.scrollToOption(item.id);
        };
        itemCounter++;
        return __jsx(NotificationListItem, {
          visible: itemCounter <= _this2.MAX_VISIBLE_NOTIFICIATIONS || showAll,
          key: "notification-ordersToConfirm-".concat(i),
          "data-id": "homestudio_OptionNotifications_NotificationListItem"
        }, __jsx(ButtonCaret, {
          clickHandler: handleOptionClick,
          color: colorPalette.blue,
          label: item.title,
          "data-id": "homestudio_OptionNotifications_ButtonCaret"
        }));
      })))), notificationAmount > this.MAX_VISIBLE_NOTIFICIATIONS && __jsx(ToggleButton, {
        show: expanded,
        onClick: this.toggleShowAll,
        "data-id": "homestudio_OptionNotifications_ToggleButton"
      }, __jsx("span", {
        "data-id": "homestudio_OptionNotifications_span"
      }, "Toon ", showAll ? 'minder' : 'alle', " notificaties"), __jsx(Caret, {
        direction: showAll ? 'up' : 'down',
        color: colorPalette.blue,
        "data-id": "homestudio_OptionNotifications_Caret"
      }))), __jsx(ExpandButton, {
        expandable: true,
        color: colorPalette.lightOrange,
        onClick: this.toggleExpansion,
        "data-id": "homestudio_OptionNotifications_ExpandButton"
      }, expanded ? __jsx(Cross, {
        color: "white",
        width: 12,
        height: 12,
        "data-id": "homestudio_OptionNotifications_Cross"
      }) : __jsx(Expand, {
        color: "white",
        "data-id": "homestudio_OptionNotifications_Expand"
      }))), __jsx(Triangle, {
        color: colorPalette.orange,
        direction: flippedButton ? 'topright' : 'topleft',
        width: 30,
        height: 30,
        "data-id": "homestudio_OptionNotifications_Triangle"
      }));
    }
  }]);
}(PureComponent);
export default OptionNotifications;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-bottom: 10rem;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: calc(100% + 30px);\n  "]))));
var ExpandButton = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border: none;\n  padding: 25rem 9rem;\n  width: 30px;\n  box-sizing: border-box;\n  display: flex;\n  cursor: ", ";\n  flex-direction: column;\n  background-color: ", ";\n\n  ", ";\n"])), function (props) {
  return props.expandable ? 'pointer' : 'default';
}, function (props) {
  return darken(props.color, 10);
}, fromBreakpoint.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding: 40rem 9rem;\n  "]))));
var NotificationContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n"])));
var NotificationText = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  background-color: rgba(", ", 0.25);\n  box-sizing: border-box;\n  padding: 20rem;\n  width: 100%;\n\n  p {\n    margin: 0;\n  }\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.color;
}, fromBreakpoint.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    padding: 32rem 40rem;\n  "]))), fromBreakpoint.lg(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    padding: 32rem 40rem 32rem 100rem;\n  "]))));
var NotificationTitle = styled.h4(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ", ";\n  color: ", ";\n  margin: ", ";\n  transition: margin 0.5s ease;\n\n  > span {\n    margin-left: 11px;\n  }\n"])), textStyles.title, colorPalette.orange, function (props) {
  return props.expanded ? "0 0 20rem" : 0;
});
var NotificationLists = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  transition: max-height 0.5s ease, opacity 0.5s ease, visibility 0.5s ease;\n  opacity: ", ";\n  visibility: ", ";\n  max-height: ", ";\n"])), function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return props.show ? 'visible' : 'hidden';
}, function (props) {
  return props.show ? 'auto' : 0;
});
var NotificationCategory = styled.h5(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-style: normal;\n  margin: 0 0 12rem;\n"])), textStyles.subTitle, colorPalette.headerGrey);
var NotificationList = styled.ul(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0 0 18rem;\n  list-style: none;\n  font-style: normal;\n"])));
var NotificationListItem = styled.li(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  margin: 0 0 12rem;\n\n  display: ", ";\n\n  ", ";\n  font-weight: bold;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])), function (props) {
  return props.visible ? 'block' : 'none';
}, textStyles.caption);
var ToggleButton = styled.button(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-style: normal;\n  display: ", ";\n\n  > span {\n    margin-right: 8rem;\n  }\n"])), textStyles.subTitle, colorPalette.blue, function (props) {
  return props.show ? 'block' : 'none';
});